export const LICENSE_REMIND_REQUEST = 'LICENSE_REMIND_REQUEST';
export const LICENSE_REMIND_SUCCESS = 'LICENSE_REMIND_SUCCESS';
export const LICENSE_REMIND_FAILURE = 'LICENSE_REMIND_FAILURE';
